import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Vuex from 'vuex'
import { store } from '@/store'
import VueCarousel from 'vue-carousel'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap and BootstrapVue CSS files (order is important)

//you need to import the CSS manually
import VueScrollactive from 'vue-scrollactive'
import YmapPlugin from 'vue-yandex-maps'
import VueScrollTo from 'vue-scrollto'
import Meta from 'vue-meta'
import VTouch from 'vue2-touch-events'
import VueCookies from 'vue-cookies'



import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue2-animate/dist/vue2-animate.min.css";
import('./assets/css/main.css')

Vue.use(Meta)
Vue.use(VueCookies)
Vue.use(VueScrollactive)
Vue.use(VTouch)
Vue.use(Vuex)
Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: 0,
	lazy: false,
	force: false,
	cancelable: false,
	x: false,
	y: true
})

const settings = {
	apiKey: '73fd3c42-b190-47c3-a5df-4850c1f9d879',
	lang: 'ru_RU',
	coordorder: 'latlong',
	enterprise: true,
	version: '2.1',
}

Vue.use(YmapPlugin, settings)
// Vue.config.productionTip = false
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueCarousel)

Vue.prototype.$url= window.location.origin;

new Vue({
	router: router,
	store: store,
	render: h => h(App),
}).$mount('#app')
